<section class="empty-msg">
    <h2>
        <app-string [key_name]="app_string_title"></app-string>
    </h2>
    <img [src]="img_url" alt="" />
</section>
